export default __webpack_public_path__ + "static/media/portada.3ff112ec.jpg";